import * as A11yDialog from 'a11y-dialog';

// This file handles "data-modal-no-video" modals
// The starter-kit.js file handles "data-modal" modals

// The starter-kit.js file will throw errors on close
// if you give it a modal without a video

export class Modal {
    modal: any;
    modalElement: HTMLElement;

    constructor(modalElement: HTMLElement, container?: HTMLElement, makeGlobal?: boolean) {
        let args = container != null ? [modalElement, container] : [modalElement];
        if (makeGlobal) {
            let modalId = modalElement.getAttribute('id');

            this[modalId] = new A11yDialog(...args);
            this[modalId].on('show', () => {
                document.body.style.overflow = 'hidden';
            });
            this[modalId].on('hide', () => {
                document.body.style.overflow = '';
            });

            (window as any)[modalId] = this[modalId];
        } else {
            this.modal = new A11yDialog(...args);
            this.modal.on('show', () => {
                document.body.style.overflow = 'hidden';
            });
            this.modal.on('hide', () => {
                document.body.style.overflow = '';
            });
        }

        this.modalElement = modalElement;
    }
}
